// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"542":"2246a7a3","824":"eddc342f"}[chunkId] + ".js";
};